import React from 'react';
import { Button, Drawer } from 'antd';
import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import AppStoreBadges from '../../AppStoreBadges';
import { getSiteNavigation } from './siteNavigation';
import SiteLogoLink from './SiteLogoLink';

function MenuSheet({
  id,
  open,
  onClose,
  onAfterClose,
  onLinkAction,
  isLoggedIn,
}) {
  const handleAfterOpenChange = (open) => {
    if (!open) {
      onAfterClose();
    }
  };

  const renderLink = ({ label, to, href, action }) => {
    const content = (
      <>
        <span className='gMedium fs-16 sb-blue-900'>{label}</span>
        <RightOutlined className='grey-500' aria-hidden='true' />
      </>
    );
    if (to) {
      return (
        <Link
          to={to}
          className='sh-row grey-border-200 hover:grey-bg-100'
          onClick={onClose}
        >
          {content}
        </Link>
      );
    }
    if (href) {
      return (
        <a
          href={href}
          className='sh-row grey-border-200 hover:grey-bg-100'
          onClick={onClose}
        >
          {content}
        </a>
      );
    }
    return (
      <Button
        type='text'
        className='sh-row grey-border-200 hover:grey-bg-100'
        onClick={() => onLinkAction(action)}
      >
        {content}
      </Button>
    );
  };

  const accountActions = isLoggedIn ? (
    <div className='display-flex-column gap-05r'>
      <Link
        to='/user/profile'
        className='sh-cta hover:grey-bg-100 row-center justify-center gBold fs-16 sb-blue-900 br14'
        onClick={onClose}
      >
        My Profile
      </Link>
      <Button
        type='link'
        className='gMedium fs-15 sb-blue-900'
        onClick={() => onLinkAction('logOut')}
      >
        <span className='txt-underline'>Log out</span>
      </Button>
    </div>
  ) : (
    <div className='display-flex-column gap-05r'>
      <Link
        to='/join'
        className='sh-cta hover:grey-bg-100 row-center justify-center gBold fs-16 sb-blue-900 br14'
        onClick={onClose}
      >
        Create Account
      </Link>
      <Link
        to='/join'
        className='gMedium fs-15 sb-blue-900 txt-center'
        onClick={onClose}
      >
        <span className='txt-underline'>or Login here</span>
      </Link>
    </div>
  );

  const menuContent = (
    <>
      {accountActions}
      {getSiteNavigation(isLoggedIn).map(({ title, links }) => (
        <section key={title} aria-label={title}>
          <h3 className='sh-eyebrow gBold fs-14 uppercase sb-blue-500 mg-bottom-0'>
            {title}
          </h3>
          <ul className='sh-list pd-0 mg-0'>
            {links.map((link) => (
              <li key={link.label}>{renderLink(link)}</li>
            ))}
          </ul>
        </section>
      ))}
      <section aria-label='Get The swimbooker App'>
        <h3 className='sh-eyebrow gBold fs-14 uppercase sb-blue-500 mg-bottom-10'>
          Get The swimbooker App
        </h3>
        <AppStoreBadges height={48} />
      </section>
    </>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      afterOpenChange={handleAfterOpenChange}
      placement='right'
      width='100%'
      closable={false}
      forceRender
      className='sh-sheet'
    >
      <div className='sh-sheet__header row-center justify-between'>
        <SiteLogoLink variant='dark' onClick={onClose} />
        <Button
          shape='circle'
          className='sh-close grey-bg-100'
          aria-label='Close menu'
          icon={<CloseOutlined />}
          onClick={onClose}
        />
      </div>
      <nav id={id} aria-label='Main menu' className='sh-sheet__content'>
        {menuContent}
      </nav>
    </Drawer>
  );
}

export default MenuSheet;
